<style src="dropzone/dist/dropzone.css"></style>

<style lang="scss">
    @import "../../assets/sass/_mixins.scss";

    @include keyframes(progress-bar-stripes) {
        from { background-position: 0 0; }
        to { background-position: 40px 40px; }
    }

    @mixin striped-bg($bg-color: #f7f8f9, $darken-amount: 5%, $stripe-color: darken($bg-color, $darken-amount)) {
      background-color: $bg-color;
      background-image: linear-gradient(-45deg, $stripe-color 25%, transparent 25%, transparent 50%, $stripe-color 50%, $stripe-color 75%, transparent 75%, transparent);
      background-size: 40px 40px;
    }

    .dropzone {
        min-height: auto;
        padding: 0;
        border: none;

        .box_upload {
            width: 100%;
            border-radius: 3px;
            box-shadow: 0 0 0 1px #EBEFF2;
            background-color: #F4F8FB;
            cursor: pointer;
            padding: 30px 15px;
            text-align: center;
            font-size: 15px;
            color: #777;

            i {
                @include transition(all, 0.2s, ease-out);
            }

            &:hover i {
                -webkit-transform: scale(1.2);
                -ms-transform: scale(1.2);
                transform: scale(1.2);
            }
        }

        .dz-preview {
            margin: 0;
            padding: 7px;
            width: 25%;

            .dz-image {
                border-radius: 4px!important;
                width: 100%;

                img {
                    width: 100%;
                    max-width: 100%;
                    position: relative;
                    top: 50%;
                    left: 50%;
                    -webkit-transform: translate(-50%, -50%);
                    -moz-transform: translate(-50%, -50%);
                    transform: translate(-50%, -50%);
                }
            }

            .dz-error-message {
                left: 0;
                width: 100%;
                word-break: break-word;
            }
        }

        &.dz-drag-hover {
            border: none;

            .box_upload {
                opacity: 1;
                @include animation(progress-bar-stripes 1s linear infinite);
                @include striped-bg();
            }
        }
    }

    .box_files {
        margin: 20px 0 0;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
        border-radius: 3px;

        .icon_file {
            text-align: center;
            display: block;
            padding: 30px 10px;
            background: #f1f4f9;

            i {
                line-height: 100%;
                color: #9aa3b3;
                @include transition(all, 0.2s, ease-out);
            }

        }

        &:hover .icon_file i {
            -webkit-transform: scale(1.2);
            -ms-transform: scale(1.2);
            transform: scale(1.2);
        }

        input {
            display: block;
            width: 100%;
            line-height: 150%;
            margin-bottom: 5px;
            border: none;
            text-overflow: ellipsis;
            border-bottom: dotted 1px #fff;
            @include transition(all, 0.2s, ease-out);

            &:focus {
                box-shadow: none;
                outline: none;
                border-bottom: dotted 1px #ccc;
            }
        }
    }

    @media (max-width: 650px) {
        .dropzone .dz-preview {
            width: 33.33333%;
        }
    }

    @media (max-width: 500px) {
        .dropzone .dz-preview {
            width: 50%;
        }
    }
</style>

<template>
    <div class="dropzone">
        <div class="box_upload dz-default dz-message">
            <i class="fa fa-upload fa-2x"></i>
            <p class="m-t-10">{{ $t('drop_file_or_click_to_upload') }}</p>
            <small class="show m-t-20">
                <p class="m-0"><strong>{{ $t('valid_extensions') }}: </strong>{{ acceptedFiles }}</p>
                <p><strong>{{ $t('maximum_size') }}: </strong>{{maxSize}}mb</p>
            </small>
        </div>
    </div>
</template>

<script>
    import Dropzone from 'dropzone'

    export default {
        props: [ 'link', 'maxFileSize', 'acceptedFiles' ],
        computed: {
            maxSize () {
                return this.maxFileSize ? this.maxFileSize : 5
            }
        },
        mounted () {
            Dropzone.options.myAwesomeDropzone = false
            Dropzone.autoDiscover = false

            var myDropzone = new Dropzone(this.$el, {
                url: process.env.URL_API + this.link,
                paramName: 'file',
                method: this.method || 'post',
                maxFilesize: this.maxSize, // MB
                acceptedFiles: this.acceptedFiles || '',
                headers: {
                    'Accept-Language': window.localStorage.getItem('pml_lang') || 'en-US',
                    'Authorization': `Bearer ${window.localStorage.getItem('pml_token')}`
                }
            })

            myDropzone.on('success', (file, response) => {
                this.$emit('upload', response)
            })
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/form/Dropzone.vue